(() => {
  const hero = document.querySelector('.mnl-collection-hero');
  if (!hero) return;
  const url = new URL(window.location.href);
  const availability = url.searchParams.get('filter.v.availability');
  const soon = /\/collections\/neuheiten\/coming-soon\/?$/i.test(url.pathname);
  const all = !soon && availability === null && url.searchParams.get('mnl') === 'all';
  const selected = soon ? 'soon' : all ? 'all' : availability === '0' ? null : 'available';
  document.querySelectorAll('.mnl-collection-hero [data-mnl-tab]').forEach((link) => {
    if (link.dataset.mnlTab === selected) link.setAttribute('aria-current', 'page');
  });
  if (window.Shopify?.designMode) return;
  if (!soon && availability === null && !all) {
    url.searchParams.set('filter.v.availability', '1');
    window.location.replace(url.toString());
  }
})();
